module.exports = __webpack_public_path__ + "img/logiciels.528d5656.png";